<template>
  <div class="content-login px-5" style="background-color: #fe715f">
    <div
      :class="[
        'content-login--form',
        height < 500 ? 'content-login--form---mobile' : '',
      ]"
    >
      <LoginFormLeft />
      <LoginFormRight :loading="loading" @login="login" />
    </div>
  </div>
</template>

<script>
import { isLogged, getToken, getTypeUser } from '@/utils';
import {
  redirectToPanelV4ForUser,
  redirectToPanelV4IfPreferred,
} from '@/utils/panelV4';
import { TYPE_USER } from '@/utils/enums';
import BreakPointMixin from '@/mixins/BreakPointMixin';
import LoginFormLeft from './components/LoginFormLeft';
import LoginFormRight from './components/LoginFormRight';

const ADMIN_LAYOUT_ROLES = [
  TYPE_USER.SUPER,
  TYPE_USER.DISTRIBUTOR,
  TYPE_USER.RESELLER,
];

export default {
  name: 'Login',
  components: { LoginFormLeft, LoginFormRight },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    l() {
      return this.$locales.pt.auth.login;
    },
  },
  mixins: [BreakPointMixin],
  mounted() {
    if (redirectToPanelV4IfPreferred()) return;

    if (getToken() && redirectToPanelV4ForUser()) return;

    if (isLogged) this.$router.push({ name: 'home' });
  },
  methods: {
    login(user) {
      this.loading = true;
      this.$api.auth
        .login(user)
        .then(() => {
          this.loading = false;

          if (redirectToPanelV4ForUser()) return;

          if (ADMIN_LAYOUT_ROLES.includes(getTypeUser())) {
            window.location = `${import.meta.env.VITE_URL}/admin`;

            return;
          }

          window.location = import.meta.env.VITE_URL;
        })
        .catch((err) => {
          this.loading = false;

          if (err.response.status === 401) {
            this.$noty.error(this.l.noty.emailOrPasswordInvalid);
          } else {
            this.$noty.error(this.l.noty.errorLogin);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '../styles.scss';
</style>
